module.exports = __webpack_public_path__ + "img/icon-tab-member-active.d19e985d.png";